import { GET_CURSOR, GET_NEXT_POST } from './nextPostQuerys'

const endpoint = process.env.GATSBY_SOURCE_WORDPRESS_URL

export const getNextPost = async (
  cursor,
  categorySlug,
  authorId = '',
  postsIds,
) => {
  const data = await fetchData(GET_NEXT_POST(cursor, categorySlug, authorId), {
    cursor,
    categorySlug,
    authorId,
    postsIds,
  })

  if (data) {
    const cursor = data?.posts?.edges[0]?.cursor
    const post = data?.posts?.edges[0]?.node

    if (post && cursor) return { post, cursor }
  }

  return null
}

export const getCursor = async slug => {
  const data = await fetchData(GET_CURSOR, { slug })

  if (data) {
    const cursor = data?.posts?.edges[0]?.cursor
    return cursor
  }

  return null
}

const fetchData = async (query, variables) => {
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    })

    if (!response.ok) {
      return null
    }

    const result = await response.json()
    return result?.data
  } catch (error) {
    // Handle errors
    return null
  }
}
